<div class="container" [class.example-is-mobile]="mobileQuery.matches">
  <mat-toolbar
    color="primary"
    class="toolbar"
    fxLayout="row"
    fxLayoutAlign="space-between center"
  >
    <div>
      <button mat-icon-button (click)="snav.toggle()">
        <mat-icon class="white-icon">menu</mat-icon>
      </button>
    </div>
    <div
      fxLayout="row"
      fxLayoutAlign="space-between center"
      class="top-navigation-content"
    >
      @if (env === "DEVELOPMENT") {
        <div class="environment-label">DEVELOPMENT</div>
      }
    </div>
    <div>
      <app-filterable-select
        class="app-filterable-select"
        (dataChange)="selectedErfassungswelleChanged($event)"
      ></app-filterable-select>
    </div>
  </mat-toolbar>

  <mat-sidenav-container
    class="example-sidenav-container"
    [style.marginTop.px]="mobileQuery.matches ? 56 : 0"
  >
    <mat-sidenav
      #snav
      id="sidenav"
      [mode]="mobileQuery.matches ? 'over' : 'side'"
      [opened]="!mobileQuery.matches"
      [fixedInViewport]="mobileQuery.matches"
      fixedTopGap="56"
      class="navigation-container"
    >
      <app-navigation></app-navigation>
    </mat-sidenav>

    <mat-sidenav-content class="content-container">
      <router-outlet></router-outlet>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
